export default {
  v: "5.5.7",
  meta: {
    g: "LottieFiles AE 0.1.20",
    a: "Martin Simeonov",
    k: "",
    d: "JSON tooth icon",
    tc: "none"
  },
  fr: 60,
  ip: 0,
  op: 241,
  w: 512,
  h: 512,
  nm: "ic_tooth",
  ddd: 0,
  assets: [],
  layers: [
    {
      ddd: 0,
      ind: 1,
      ty: 4,
      nm: "Shape Layer 7",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 33, ix: 10 },
        p: { a: 0, k: [260.5, 248.5, 0], ix: 2 },
        a: { a: 0, k: [40.5, 108.5, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              d: 1,
              ty: "el",
              s: { a: 0, k: [361, 135], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              nm: "Ellipse Path 1",
              mn: "ADBE Vector Shape - Ellipse",
              hd: false
            },
            {
              ty: "tm",
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.667], y: [1] },
                    o: { x: [0.333], y: [0] },
                    t: 23,
                    s: [82]
                  },
                  { t: 41, s: [17] }
                ],
                ix: 1
              },
              e: {
                a: 1,
                k: [
                  {
                    i: { x: [0.667], y: [1] },
                    o: { x: [0.333], y: [0] },
                    t: 23,
                    s: [87]
                  },
                  { t: 59, s: [17] }
                ],
                ix: 2
              },
              o: { a: 0, k: 0, ix: 3 },
              m: 1,
              ix: 2,
              nm: "Trim Paths 1",
              mn: "ADBE Vector Filter - Trim",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [0.179992675781, 1, 0.685974121094, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: {
                a: 1,
                k: [
                  {
                    i: { x: [0.667], y: [1] },
                    o: { x: [0.333], y: [0] },
                    t: 23,
                    s: [0]
                  },
                  {
                    i: { x: [0.667], y: [1] },
                    o: { x: [0.333], y: [0] },
                    t: 41,
                    s: [1]
                  },
                  { t: 59, s: [0] }
                ],
                ix: 5
              },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [40.5, 108.5], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [112, 87.01], ix: 3 },
              r: { a: 0, k: -23, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Ellipse 1",
          np: 4,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 23,
      op: 60,
      st: -145,
      bm: 0
    },
    {
      ddd: 0,
      ind: 2,
      ty: 4,
      nm: "Shape Layer 6",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 5, ix: 10 },
        p: { a: 0, k: [260.5, 248.5, 0], ix: 2 },
        a: { a: 0, k: [40.5, 108.5, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              d: 1,
              ty: "el",
              s: { a: 0, k: [361, 135], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              nm: "Ellipse Path 1",
              mn: "ADBE Vector Shape - Ellipse",
              hd: false
            },
            {
              ty: "tm",
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.667], y: [1] },
                    o: { x: [0.333], y: [0] },
                    t: 11,
                    s: [82]
                  },
                  { t: 29, s: [17] }
                ],
                ix: 1
              },
              e: {
                a: 1,
                k: [
                  {
                    i: { x: [0.667], y: [1] },
                    o: { x: [0.333], y: [0] },
                    t: 11,
                    s: [87]
                  },
                  { t: 47, s: [17] }
                ],
                ix: 2
              },
              o: { a: 0, k: 0, ix: 3 },
              m: 1,
              ix: 2,
              nm: "Trim Paths 1",
              mn: "ADBE Vector Filter - Trim",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [0.179992675781, 1, 0.685974121094, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: {
                a: 1,
                k: [
                  {
                    i: { x: [0.667], y: [1] },
                    o: { x: [0.333], y: [0] },
                    t: 11,
                    s: [0]
                  },
                  {
                    i: { x: [0.667], y: [1] },
                    o: { x: [0.333], y: [0] },
                    t: 29,
                    s: [1]
                  },
                  { t: 47, s: [0] }
                ],
                ix: 5
              },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [40.5, 108.5], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [112, 87.01], ix: 3 },
              r: { a: 0, k: -23, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Ellipse 1",
          np: 4,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 11,
      op: 48,
      st: -157,
      bm: 0
    },
    {
      ddd: 0,
      ind: 3,
      ty: 4,
      nm: "Shape Layer 5",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: -8, ix: 10 },
        p: { a: 0, k: [260.5, 248.5, 0], ix: 2 },
        a: { a: 0, k: [40.5, 108.5, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              d: 1,
              ty: "el",
              s: { a: 0, k: [361, 135], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              nm: "Ellipse Path 1",
              mn: "ADBE Vector Shape - Ellipse",
              hd: false
            },
            {
              ty: "tm",
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.667], y: [1] },
                    o: { x: [0.333], y: [0] },
                    t: 2,
                    s: [82]
                  },
                  { t: 19, s: [17] }
                ],
                ix: 1
              },
              e: {
                a: 1,
                k: [
                  {
                    i: { x: [0.667], y: [1] },
                    o: { x: [0.333], y: [0] },
                    t: 2,
                    s: [87]
                  },
                  { t: 37, s: [17] }
                ],
                ix: 2
              },
              o: { a: 0, k: 0, ix: 3 },
              m: 1,
              ix: 2,
              nm: "Trim Paths 1",
              mn: "ADBE Vector Filter - Trim",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [0.179992675781, 1, 0.685974121094, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: {
                a: 1,
                k: [
                  {
                    i: { x: [0.667], y: [1] },
                    o: { x: [0.333], y: [0] },
                    t: 2,
                    s: [0]
                  },
                  {
                    i: { x: [0.667], y: [1] },
                    o: { x: [0.333], y: [0] },
                    t: 19,
                    s: [3]
                  },
                  { t: 37, s: [0] }
                ],
                ix: 5
              },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [40.5, 108.5], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [112, 87.01], ix: 3 },
              r: { a: 0, k: -23, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Ellipse 1",
          np: 4,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 2,
      op: 38,
      st: -149,
      bm: 0
    },
    {
      ddd: 0,
      ind: 4,
      ty: 4,
      nm: "Shape Layer 2",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 13, ix: 10 },
        p: { a: 0, k: [245.5, 236.5, 0], ix: 2 },
        a: { a: 0, k: [40.5, 108.5, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              d: 1,
              ty: "el",
              s: { a: 0, k: [361, 135], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              nm: "Ellipse Path 1",
              mn: "ADBE Vector Shape - Ellipse",
              hd: false
            },
            {
              ty: "tm",
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.667], y: [1] },
                    o: { x: [0.333], y: [0] },
                    t: 101,
                    s: [82]
                  },
                  { t: 117.30078125, s: [17] }
                ],
                ix: 1
              },
              e: {
                a: 1,
                k: [
                  {
                    i: { x: [0.667], y: [1] },
                    o: { x: [0.333], y: [0] },
                    t: 101,
                    s: [87]
                  },
                  { t: 133.603515625, s: [17] }
                ],
                ix: 2
              },
              o: { a: 0, k: 0, ix: 3 },
              m: 1,
              ix: 2,
              nm: "Trim Paths 1",
              mn: "ADBE Vector Filter - Trim",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [0.179992675781, 1, 0.685974121094, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: {
                a: 1,
                k: [
                  {
                    i: { x: [0.667], y: [1] },
                    o: { x: [0.333], y: [0] },
                    t: 101,
                    s: [0]
                  },
                  {
                    i: { x: [0.667], y: [1] },
                    o: { x: [0.333], y: [0] },
                    t: 117.301,
                    s: [2]
                  },
                  { t: 133.603515625, s: [0] }
                ],
                ix: 5
              },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [40.5, 108.5], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [112, 87.01], ix: 3 },
              r: { a: 0, k: -23, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Ellipse 1",
          np: 4,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 101,
      op: 134,
      st: -67,
      bm: 0
    },
    {
      ddd: 0,
      ind: 5,
      ty: 4,
      nm: "Shape Layer 1",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [245.5, 236.5, 0], ix: 2 },
        a: { a: 0, k: [40.5, 108.5, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              d: 1,
              ty: "el",
              s: { a: 0, k: [361, 135], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              nm: "Ellipse Path 1",
              mn: "ADBE Vector Shape - Ellipse",
              hd: false
            },
            {
              ty: "tm",
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.667], y: [1] },
                    o: { x: [0.333], y: [0] },
                    t: 94,
                    s: [82]
                  },
                  { t: 109, s: [17] }
                ],
                ix: 1
              },
              e: {
                a: 1,
                k: [
                  {
                    i: { x: [0.667], y: [1] },
                    o: { x: [0.333], y: [0] },
                    t: 94,
                    s: [87]
                  },
                  { t: 125.30078125, s: [17] }
                ],
                ix: 2
              },
              o: { a: 0, k: 0, ix: 3 },
              m: 1,
              ix: 2,
              nm: "Trim Paths 1",
              mn: "ADBE Vector Filter - Trim",
              hd: false
            },
            {
              ty: "st",
              c: { a: 0, k: [0.179992675781, 1, 0.685974121094, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: {
                a: 1,
                k: [
                  {
                    i: { x: [0.667], y: [1] },
                    o: { x: [0.333], y: [0] },
                    t: 94,
                    s: [0]
                  },
                  {
                    i: { x: [0.667], y: [1] },
                    o: { x: [0.333], y: [0] },
                    t: 109,
                    s: [15]
                  },
                  { t: 125.30078125, s: [0] }
                ],
                ix: 5
              },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [40.5, 108.5], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [112, 87.01], ix: 3 },
              r: { a: 0, k: -23, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Ellipse 1",
          np: 4,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 94,
      op: 126,
      st: -57,
      bm: 0
    },
    {
      ddd: 0,
      ind: 6,
      ty: 4,
      nm: "Layer 2 Outlines",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: {
          a: 1,
          k: [
            {
              i: { x: [0.601], y: [1] },
              o: { x: [0.162], y: [0] },
              t: 168,
              s: [0]
            },
            {
              i: { x: [0.667], y: [1] },
              o: { x: [0.429], y: [0] },
              t: 212,
              s: [-11]
            },
            { t: 240, s: [184] }
          ],
          ix: 10
        },
        p: { a: 0, k: [141.898, 144.61, 0], ix: 2 },
        a: { a: 0, k: [149.898, 150.61, 0], ix: 1 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0, 0, 0.667], y: [1, 1, 1] },
              o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
              t: 162.541,
              s: [0, 0, 100]
            },
            {
              i: { x: [0, 0, 0.667], y: [1, 1, 1] },
              o: { x: [0.167, 0.167, 0.167], y: [0, 0, 0] },
              t: 187,
              s: [100, 100, 100]
            },
            {
              i: { x: [0.833, 0.833, 0.833], y: [1, 1, 1] },
              o: { x: [0.167, 0.167, 0.167], y: [0, 0, 0] },
              t: 212.541,
              s: [100, 100, 100]
            },
            { t: 239.65625, s: [0, 0, 100] }
          ],
          ix: 6
        }
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  v: [
                    [-0.008, -47.883],
                    [12.68, -12.704],
                    [47.883, -0.008],
                    [12.68, 12.695],
                    [-0.008, 47.883],
                    [-12.711, 12.695],
                    [-47.883, -0.008],
                    [-12.711, -12.704]
                  ],
                  c: true
                },
                ix: 2
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false
            },
            {
              ty: "st",
              c: {
                a: 0,
                k: [1, 0.8862745098039215, 0.30196078431372547, 1],
                ix: 3
              },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 4, ix: 5 },
              lc: 2,
              lj: 2,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false
            },
            {
              ty: "tr",
              p: { a: 0, k: [149.898, 150.61], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform"
            }
          ],
          nm: "Group 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false
        }
      ],
      ip: 0,
      op: 241,
      st: 0,
      bm: 0
    },
    {
      ddd: 0,
      ind: 8,
      ty: 4,
      nm: "Layer 4 Outlines",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [251.282, 135.179, 0], ix: 2 },
        a: { a: 0, k: [259.282, 141.179, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 }
      },
      ao: 0,
      shapes: [
        {
          ind: 0,
          ty: "sh",
          ix: 1,
          ks: {
            a: 1,
            k: [
              {
                i: { x: 0.667, y: 1 },
                o: { x: 0.333, y: 0 },
                t: 0,
                s: [
                  {
                    i: [
                      [-2.424, -1.111],
                      [-17.624, -13.501],
                      [9.146, 3.566]
                    ],
                    o: [
                      [16.59, 7.606],
                      [-15.999, -10.251],
                      [-2.484, -0.969]
                    ],
                    v: [
                      [261.209, 137.675],
                      [307.124, 167.501],
                      [257.354, 144.684]
                    ],
                    c: true
                  }
                ]
              },
              {
                i: { x: 0.667, y: 1 },
                o: { x: 0.333, y: 0 },
                t: 120.4,
                s: [
                  {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    v: [
                      [261.209, 137.675],
                      [319.624, 169.501],
                      [257.354, 144.684]
                    ],
                    c: true
                  }
                ]
              },
              {
                i: { x: 0.667, y: 1 },
                o: { x: 0.333, y: 0 },
                t: 240.803,
                s: [
                  {
                    i: [
                      [-2.424, -1.111],
                      [-17.624, -13.501],
                      [9.146, 3.566]
                    ],
                    o: [
                      [16.59, 7.606],
                      [-15.999, -10.251],
                      [-2.484, -0.969]
                    ],
                    v: [
                      [261.209, 137.675],
                      [307.124, 167.501],
                      [257.354, 144.684]
                    ],
                    c: true
                  }
                ]
              },
              {
                i: { x: 0.667, y: 1 },
                o: { x: 0.333, y: 0 },
                t: 361.203,
                s: [
                  {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    v: [
                      [261.209, 137.675],
                      [294.624, 162.501],
                      [257.354, 144.684]
                    ],
                    c: true
                  }
                ]
              },
              {
                t: 480,
                s: [
                  {
                    i: [
                      [-2.424, -1.111],
                      [-17.624, -13.501],
                      [9.146, 3.566]
                    ],
                    o: [
                      [16.59, 7.606],
                      [-15.999, -10.251],
                      [-2.484, -0.969]
                    ],
                    v: [
                      [261.209, 137.675],
                      [307.124, 167.501],
                      [257.354, 144.684]
                    ],
                    c: true
                  }
                ]
              }
            ],
            ix: 2
          },
          nm: "Path 1",
          mn: "ADBE Vector Shape - Group",
          hd: false
        },
        {
          ty: "fl",
          c: {
            a: 0,
            k: [0.13725490196078433, 0.6274509803921569, 0.6274509803921569, 1],
            ix: 4
          },
          o: { a: 0, k: 100, ix: 5 },
          r: 1,
          bm: 0,
          nm: "Fill 1",
          mn: "ADBE Vector Graphic - Fill",
          hd: false
        }
      ],
      ip: 0,
      op: 241,
      st: 0,
      bm: 0
    },
    {
      ddd: 0,
      ind: 9,
      ty: 4,
      nm: "Layer 5 Outlines",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [248, 250, 0], ix: 2 },
        a: { a: 0, k: [256, 256, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 }
      },
      ao: 0,
      shapes: [
        {
          ind: 0,
          ty: "sh",
          ix: 1,
          ks: {
            a: 1,
            k: [
              {
                i: { x: 0.667, y: 1 },
                o: { x: 0.333, y: 0 },
                t: 0,
                s: [
                  {
                    i: [
                      [-10.5, -5.781],
                      [-5.954, 21.257],
                      [-22.937, 41.64],
                      [26.343, 34.86],
                      [0, 0],
                      [26.343, -34.851],
                      [-22.938, -41.641],
                      [-5.937, -21.258],
                      [-35.953, 19.812],
                      [-32.048, 0]
                    ],
                    o: [
                      [35.954, 19.812],
                      [5.953, -21.258],
                      [22.938, -41.641],
                      [-26.36, -34.851],
                      [-2.548, -0.859],
                      [-26.36, 34.86],
                      [22.922, 41.64],
                      [5.954, 21.257],
                      [10.344, -5.687],
                      [35.093, 0]
                    ],
                    v: [
                      [284.39, 404.648],
                      [351.532, 334.953],
                      [369.375, 243.164],
                      [368.532, 139.468],
                      [259.282, 141.179],
                      [150.047, 139.468],
                      [149.203, 243.164],
                      [167.031, 334.953],
                      [234.172, 404.648],
                      [259.282, 318.718]
                    ],
                    c: true
                  }
                ]
              },
              {
                i: { x: 0.667, y: 1 },
                o: { x: 0.333, y: 0 },
                t: 60.201,
                s: [
                  {
                    i: [
                      [-10.5, -5.781],
                      [-5.954, 21.257],
                      [-22.937, 41.64],
                      [26.343, 34.86],
                      [0, 0],
                      [26.343, -34.851],
                      [-22.938, -41.641],
                      [-5.937, -21.258],
                      [-35.953, 19.812],
                      [-10.282, 0]
                    ],
                    o: [
                      [35.954, 19.812],
                      [5.953, -21.258],
                      [22.938, -41.641],
                      [-26.36, -34.851],
                      [-2.548, -0.859],
                      [-26.36, 34.86],
                      [22.922, 41.64],
                      [5.954, 21.257],
                      [10.344, -5.687],
                      [27.218, 0]
                    ],
                    v: [
                      [293.39, 404.297],
                      [343.063, 355.407],
                      [357.875, 243.236],
                      [357.032, 139.54],
                      [259.282, 141.179],
                      [153.047, 144.468],
                      [152.203, 248.164],
                      [170.031, 339.953],
                      [253.672, 404.498],
                      [267.282, 318.428]
                    ],
                    c: true
                  }
                ]
              },
              {
                i: { x: 0.667, y: 1 },
                o: { x: 0.333, y: 0 },
                t: 120.4,
                s: [
                  {
                    i: [
                      [-10.5, -5.781],
                      [-5.954, 21.257],
                      [-22.937, 41.64],
                      [26.343, 34.86],
                      [0, 0],
                      [26.343, -34.851],
                      [-22.938, -41.641],
                      [-5.937, -21.258],
                      [-35.953, 19.812],
                      [-32.048, 0]
                    ],
                    o: [
                      [35.954, 19.812],
                      [5.953, -21.258],
                      [22.938, -41.641],
                      [-26.36, -34.851],
                      [-2.548, -0.859],
                      [-26.36, 34.86],
                      [22.922, 41.64],
                      [5.954, 21.257],
                      [10.344, -5.687],
                      [35.093, 0]
                    ],
                    v: [
                      [284.39, 404.648],
                      [351.532, 334.953],
                      [369.375, 243.164],
                      [368.532, 139.468],
                      [259.282, 141.179],
                      [150.047, 139.468],
                      [149.203, 243.164],
                      [167.031, 334.953],
                      [234.172, 404.648],
                      [259.282, 318.718]
                    ],
                    c: true
                  }
                ]
              },
              {
                i: { x: 0.667, y: 1 },
                o: { x: 0.333, y: 0 },
                t: 180.602,
                s: [
                  {
                    i: [
                      [-10.5, -5.781],
                      [-4.532, 36.093],
                      [-22.937, 41.64],
                      [26.343, 34.86],
                      [0, 0],
                      [26.343, -34.851],
                      [-22.938, -41.641],
                      [-5.937, -21.258],
                      [-35.953, 19.812],
                      [-32.005, -1.659]
                    ],
                    o: [
                      [35.954, 19.812],
                      [2.75, -21.904],
                      [22.938, -41.641],
                      [-26.36, -34.851],
                      [-2.548, -0.859],
                      [-26.36, 34.86],
                      [22.922, 41.64],
                      [5.954, 21.257],
                      [10.344, -5.687],
                      [24.718, 1.282]
                    ],
                    v: [
                      [276.39, 404.297],
                      [362.532, 334.907],
                      [380.375, 243.118],
                      [379.532, 139.422],
                      [259.282, 141.179],
                      [156.047, 139.422],
                      [155.203, 243.118],
                      [173.031, 334.907],
                      [234.172, 404.648],
                      [259.282, 318.718]
                    ],
                    c: true
                  }
                ]
              },
              {
                t: 240,
                s: [
                  {
                    i: [
                      [-10.5, -5.781],
                      [-5.954, 21.257],
                      [-22.937, 41.64],
                      [26.343, 34.86],
                      [0, 0],
                      [26.343, -34.851],
                      [-22.938, -41.641],
                      [-5.937, -21.258],
                      [-35.953, 19.812],
                      [-32.048, 0]
                    ],
                    o: [
                      [35.954, 19.812],
                      [5.953, -21.258],
                      [22.938, -41.641],
                      [-26.36, -34.851],
                      [-2.548, -0.859],
                      [-26.36, 34.86],
                      [22.922, 41.64],
                      [5.954, 21.257],
                      [10.344, -5.687],
                      [35.093, 0]
                    ],
                    v: [
                      [284.39, 404.648],
                      [351.532, 334.953],
                      [369.375, 243.164],
                      [368.532, 139.468],
                      [259.282, 141.179],
                      [150.047, 139.468],
                      [149.203, 243.164],
                      [167.031, 334.953],
                      [234.172, 404.648],
                      [259.282, 318.718]
                    ],
                    c: true
                  }
                ]
              }
            ],
            ix: 2
          },
          nm: "Path 1",
          mn: "ADBE Vector Shape - Group",
          hd: false
        },
        {
          ty: "st",
          c: {
            a: 0,
            k: [0.13725490196078433, 0.6274509803921569, 0.6274509803921569, 1],
            ix: 3
          },
          o: { a: 0, k: 100, ix: 4 },
          w: { a: 0, k: 8, ix: 5 },
          lc: 1,
          lj: 1,
          ml: 10,
          bm: 0,
          nm: "Stroke 1",
          mn: "ADBE Vector Graphic - Stroke",
          hd: false
        },
        {
          ty: "fl",
          c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
          o: { a: 0, k: 100, ix: 5 },
          r: 1,
          bm: 0,
          nm: "Fill 1",
          mn: "ADBE Vector Graphic - Fill",
          hd: false
        }
      ],
      ip: 0,
      op: 241,
      st: 0,
      bm: 0
    }
  ],
  markers: []
};
